module.exports = __webpack_public_path__ + "img/OM.d9766367.png";